import dayjs, { type Dayjs } from 'dayjs';

import { TIME_FORMAT, POSITION_PROPERTIES } from './constants';
import { roundToMilliseconds } from './helpers/cycle-helpers';

export function dayjsToSeconds(time: Dayjs | null): number {
	if (!time) return 0;
	const seconds =
		time.hour() * TIME_FORMAT.SECONDS_PER_HOUR + time.minute() * TIME_FORMAT.SECONDS_PER_MINUTE + time.second();
	const milliseconds = time.millisecond() / 1000;
	const roundedSeconds = roundToMilliseconds(seconds + milliseconds);

	return roundedSeconds;
}

export function secondsToDayjs(totalSeconds: number): Dayjs {
	const wholeSeconds = Math.max(POSITION_PROPERTIES.MIN_POSITION, Math.floor(totalSeconds));
	const milliseconds = Math.round((totalSeconds - wholeSeconds) * 1000);

	const hours = Math.floor(wholeSeconds / TIME_FORMAT.SECONDS_PER_HOUR);
	const minutes = Math.floor((wholeSeconds % TIME_FORMAT.SECONDS_PER_HOUR) / TIME_FORMAT.SECONDS_PER_MINUTE);
	const remainingSeconds = wholeSeconds % TIME_FORMAT.SECONDS_PER_MINUTE;
	const dayjsTime = dayjs().hour(hours).minute(minutes).second(remainingSeconds).millisecond(milliseconds);

	return dayjsTime;
}

export function formatTime(totalSeconds: number): string {
	const seconds = Math.max(POSITION_PROPERTIES.MIN_POSITION, Math.floor(totalSeconds));
	const hours = Math.floor(seconds / TIME_FORMAT.SECONDS_PER_HOUR);
	const minutes = Math.floor((seconds % TIME_FORMAT.SECONDS_PER_HOUR) / TIME_FORMAT.SECONDS_PER_MINUTE);
	const remainingSeconds = seconds % TIME_FORMAT.SECONDS_PER_MINUTE;
	const formatedTime = [hours, minutes, remainingSeconds]
		.map((num) => num.toString().padStart(TIME_FORMAT.PADDING_LENGTH, TIME_FORMAT.PADDING_CHAR))
		.join(':');

	return formatedTime;
}

export function dateToDayjs(date: Date): Dayjs {
	return dayjs(date);
}
